<script context="module">
  import Button from "../../atoms/Button.svelte";
  import Checkbox from "./Checkbox.svelte";
  import Input from "./Input.svelte";
  import CheckboxGroup from "./CheckboxGroup.svelte";
  import DateTimePicker from "./DateTimePicker.svelte";
  import EmailInput from "./EmailInput.svelte";
  import HiddenInput from "./HiddenInput.svelte";
  import PhoneNumberInput from "./PhoneNumberInput.svelte";
  import Textarea from "./Textarea.svelte";

  /**
   * @typedef {Object} FormFieldProps
   * @property {string} id
   * @property {string} name
   * @property {keyof typeof FIELD_COMPONENT_MAP} type
   * @property {string} label
   * @property {any} value
   * @property {boolean} required
   * @property {string} pattern
   * @property {string} helpText
   * @property {string} errorMessage
   *
   */

  export const FIELD_COMPONENT_MAP = {
    text: Input,
    number: Input,
    date: DateTimePicker,
    time: DateTimePicker,
    email: EmailInput,
    phone: PhoneNumberInput,
    textarea: Textarea,
    checkbox: Checkbox,
    "radio-group": CheckboxGroup, // TODO: create radio group component
    "checkbox-group": CheckboxGroup,
    "single-select": CheckboxGroup, // TODO: create radio group component
    "multi-select": CheckboxGroup,
    hidden: HiddenInput,
    submit: Button
  };
</script>

<script>
  // @ts-check
  /**
   * @type {keyof typeof FIELD_COMPONENT_MAP}
   */
  export let type = "text";
</script>

<svelte:component
  this={FIELD_COMPONENT_MAP[type]}
  {type}
  on:focus
  on:invalid
  on:click
  {...$$restProps}
>
  <slot />
</svelte:component>
